"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slider = void 0;
const plugin_html_slider_response_1 = __importDefault(require("@jspsych/plugin-html-slider-response"));
const toNumber_1 = __importDefault(require("lodash/toNumber"));
const taskSetup_1 = require("../../taskSetup");
//@ts-ignore
const roar_utils_1 = require("@bdelab/roar-utils");
const helpers_1 = require("../../shared/helpers");
const __1 = require("../../..");
const taskStore_1 = require("../../../taskStore");
let chosenAnswer;
let responseIdx;
let sliderStart;
let startTime;
function setUpAudio(cue) {
    const audioFile = __1.mediaAssets.audio[(0, roar_utils_1.camelize)(cue)] || '';
    const audioConfig = {
        restrictRepetition: {
            enabled: true,
            maxRepetitions: 2,
        },
        onEnded: () => {
            // set up replay button audio after the first audio has played
            if (cue) {
                const pageStateHandler = new helpers_1.PageStateHandler(cue, true);
                (0, helpers_1.setupReplayAudio)(pageStateHandler);
                (0, helpers_1.addExperimenterButtons)();
                (0, helpers_1.setupFullscreenButton)();
            }
        },
    };
    helpers_1.PageAudioHandler.playAudio(audioFile, audioConfig);
}
function captureValue(btnElement, event, i, isPractice, choice) {
    chosenAnswer = choice ? (0, toNumber_1.default)(choice) : (0, toNumber_1.default)(btnElement === null || btnElement === void 0 ? void 0 : btnElement.textContent);
    responseIdx = i;
    if (!isPractice) {
        taskSetup_1.jsPsych.finishTrial();
    }
}
function getRandomValue(max, avoid, tolerance = 0.1) {
    const scaled_avoid = avoid / max;
    let result = Math.random();
    while (Math.abs(result - scaled_avoid) < tolerance) {
        result = Math.random();
    }
    return result * max;
}
const slider = (layoutConfigMap, terminateCat, trial) => {
    return {
        type: plugin_html_slider_response_1.default,
        data: () => {
            return {
                save_trial: true,
                assessment_stage: (trial || (0, taskStore_1.taskStore)().nextStimulus).assessmentStage,
                isPracticeTrial: (trial || (0, taskStore_1.taskStore)().nextStimulus).assessmentStage === 'practice_response',
            };
        },
        stimulus: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            let t = (0, taskStore_1.taskStore)().translations;
            const isSlider = stim.trialType === 'Number Line Slider';
            return `
      <div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)('replay-btn-revisited')}
          ${stim.trialType !== 'Number Line Buttons'
                ? `<div class="lev-row-container instruction">
                <p>
                  ${t[(0, roar_utils_1.camelize)(stim.audioFile)]}
                  ${isSlider ? '<br /> ' + stim.answer : ''}
                </p> 
              </div>`
                : ''}
      </div>
    `;
        },
        labels: () => (trial || (0, taskStore_1.taskStore)().nextStimulus).item,
        // button_label: 'OK',
        require_movement: () => (trial || (0, taskStore_1.taskStore)().nextStimulus).trialType === 'Number Line Slider',
        // slider_width: 800,
        min: () => (trial || (0, taskStore_1.taskStore)().nextStimulus).item[0],
        max: () => (trial || (0, taskStore_1.taskStore)().nextStimulus).item[1],
        // max: () => (taskStore().nextStimulus.item[1] === 1 ? 100 : taskStore().nextStimulus.item[1]),
        slider_start: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            if (stim.trialType.includes('Slider')) {
                // const max = stim.item[1] === 1 ? 100 : stim.item[1];
                const max = stim.item[1];
                sliderStart = getRandomValue(max, stim.answer);
            }
            else if (stim.trialType === 'Number Line 4afc') {
                sliderStart = stim.answer;
            }
            else {
                sliderStart = stim.item[1];
            }
            return sliderStart;
        },
        // step: 1,
        step: 'any',
        // add gap if it is a practice trial because setup trial will not be immediately after
        post_trial_gap: () => ((trial || (0, taskStore_1.taskStore)().nextStimulus).assessmentStage === 'practice_response' ? 350 : 0),
        on_load: () => {
            startTime = performance.now();
            const stim = (trial || (0, taskStore_1.taskStore)().nextStimulus);
            const { distractors } = stim;
            const itemLayoutConfig = layoutConfigMap[stim.itemId];
            const incorrectPracticeResponses = [];
            (0, taskStore_1.taskStore)('incorrectPracticeResponses', incorrectPracticeResponses);
            const slider = document.getElementById('jspsych-html-slider-response-response');
            const sliderLabels = document.getElementsByTagName('span');
            Array.from(sliderLabels).forEach((el, i) => {
                //if (i == 1 || i == 2) {
                el.style.fontSize = '1.5rem';
                //}
            });
            const { buttonLayout } = (0, taskStore_1.taskStore)();
            const isPractice = stim.assessmentStage === 'practice_response';
            const response = layoutConfigMap[stim.itemId].response;
            const answer = (0, toNumber_1.default)(response.target);
            (0, taskStore_1.taskStore)('target', answer);
            (0, taskStore_1.taskStore)('choices', response.values);
            const responseChoices = response.values;
            // Setup Sentry Context
            (0, helpers_1.setSentryContext)({
                itemId: stim.itemId,
                taskName: stim.task,
                pageContext: 'sliderStimulus',
            });
            const wrapper = document.getElementById('jspsych-html-slider-response-wrapper');
            const responseRow = document.createElement('div');
            responseRow.style.display = 'flex';
            responseRow.style.justifyContent = 'center';
            responseRow.style.alignItems = 'center';
            const buttonContainer = document.createElement('div');
            const sliderContainer = document.getElementsByClassName('jspsych-html-slider-response-container')[0];
            if (buttonLayout === 'diamond' && response.values.length === 4) {
                // have to do it in the runtime
                buttonContainer.classList.add('lev-response-row-diamond-layout');
            }
            else {
                buttonContainer.classList.add(...itemLayoutConfig.classOverrides.buttonContainerClassList);
            }
            if (stim.trialType === 'Number Line 4afc') {
                // don't let participant move slider
                const progress = (Number(slider.value) * 100) / (Number(slider.max) - Number(slider.min));
                slider.classList.add('number-line-4afc-slider');
                slider.disabled = true;
                slider.style.background = `linear-gradient(to right, #275BDD ${progress}%, #edf0ed ${progress}%)`;
                wrapper.style.margin = '0 0 2rem 0';
                // disable continue button and make invisible
                const continueBtn = document.getElementById('jspsych-html-slider-response-next');
                continueBtn.disabled = true;
                continueBtn.style.visibility = 'hidden';
                // create buttons
                for (let i = 0; i < responseChoices.length; i++) {
                    const btnWrapper = document.createElement('div');
                    btnWrapper.style.margin = '0px 8px';
                    const btn = document.createElement('button');
                    btn.textContent = responseChoices[i];
                    // flag correct answer if running in cypress
                    if (window.Cypress && (0, toNumber_1.default)(btn.textContent) == answer) {
                        btn.setAttribute('aria-label', 'correct');
                    }
                    btn.classList.add('secondary');
                    if (stim.assessmentStage === 'practice_response') {
                        btn.classList.add('practice-btn');
                    }
                    btn.addEventListener('click', (e) => captureValue(btn, e, i, isPractice));
                    btnWrapper.appendChild(btn);
                    buttonContainer.appendChild(btnWrapper);
                }
            }
            else if (stim.trialType === 'Number Line Slider') {
                const continueBtn = document.getElementById('jspsych-html-slider-response-next');
                if (continueBtn) {
                    continueBtn.classList.add('primary');
                }
                const slider = document.getElementById('jspsych-html-slider-response-response');
                slider.addEventListener('input', () => (chosenAnswer = Number(slider.value)));
            }
            else {
                // disable continue button and make invisible
                const continueBtn = document.getElementById('jspsych-html-slider-response-next');
                continueBtn.disabled = true;
                continueBtn.style.visibility = 'hidden';
                // lower labels to give room for slider buttons
                const labels = sliderContainer.children[1].children;
                for (let i = 0; i < labels.length; i++) {
                    labels[i].style.top = '50px';
                }
                // add slider styling
                const progress = (Number(slider.value) * 100) / (Number(slider.max) - Number(slider.min));
                slider.disabled = true;
                slider.style.background = `linear-gradient(to right, #275BDD ${progress}%, #edf0ed ${progress}%)`;
                slider.classList.add('number-line-buttons');
                // overlay response buttons on top of slider
                responseChoices.forEach((choice, i) => {
                    const sliderButton = document.createElement('button');
                    if (stim.assessmentStage === 'practice_response') {
                        sliderButton.classList.add('practice-btn');
                    }
                    sliderButton.classList.add('slider');
                    sliderButton.style.position = 'absolute';
                    sliderButton.style.top = '-12px';
                    const stepPercent = 100 / Number(slider.max);
                    sliderButton.style.left = `calc(${stepPercent * Number(choice)}% - ${stepPercent / 2}%)`;
                    sliderButton.addEventListener('click', (e) => captureValue(sliderButton, e, i, isPractice, choice));
                    sliderContainer.appendChild(sliderButton);
                });
            }
            responseRow.appendChild(buttonContainer);
            wrapper.appendChild(responseRow);
            if (typeof stim.audioFile === 'string') {
                setUpAudio(stim.audioFile);
            }
            else {
                throw new Error('Multiple audio files are not supported in this trial type');
            }
            if (isPractice) {
                let feedbackHandler;
                const answer = stim.answer.toString();
                const choices = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId].response.values;
                feedbackHandler = (0, helpers_1.addPracticeButtonListeners)(answer, taskSetup_1.isTouchScreen, choices);
            }
        },
        on_finish: (data) => {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            const stimulus = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const isPractice = stimulus.assessmentStage === 'practice_response';
            const endTime = performance.now();
            const runCat = (0, taskStore_1.taskStore)().runCat;
            const sliderScoringThreshold = 0.05; // proportion of maximum slider value that response must fall within to be scored correct
            if (stimulus.trialType === 'Number Line 4afc' || stimulus.trialType === 'Number Line Buttons') {
                if (isPractice) {
                    data.correct = (0, taskStore_1.taskStore)().incorrectPracticeResponses.length === 0;
                }
                else {
                    data.correct = chosenAnswer === (0, taskStore_1.taskStore)().target;
                }
            }
            else {
                data.correct = Math.abs(chosenAnswer - stimulus.answer) / stimulus.item[1] < sliderScoringThreshold;
            }
            // update taskStore
            (0, taskStore_1.taskStore)('isCorrect', data.correct);
            if (!isPractice) {
                if (data.correct) {
                    (0, taskStore_1.taskStore)('numIncorrect', 0);
                    taskStore_1.taskStore.transact('totalCorrect', (oldVal) => oldVal + 1);
                }
                else {
                    taskStore_1.taskStore.transact('numIncorrect', (oldVal) => oldVal + 1);
                }
                if (runCat) {
                    (0, helpers_1.updateTheta)(stimulus, data.correct);
                }
            }
            const response = chosenAnswer;
            const responseType = stimulus.trialType.includes('Slider')
                ? 'slider'
                : stimulus.trialType.includes('4afc')
                    ? 'button'
                    : 'slider-button';
            const answer = stimulus.answer;
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                item: stimulus.item,
                answer: answer,
                response: (0, toNumber_1.default)(response),
                responseType: responseType,
                distractors: stimulus.distractors,
                corpusTrialType: stimulus.trialType,
                // slider_start: stimulus.item[1] === 1 ? sliderStart / 100 : sliderStart,
                slider_start: sliderStart,
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                itemUid: stimulus.itemUid,
                audioFile: stimulus.audioFile,
                corpus: (0, taskStore_1.taskStore)().corpus,
            });
            if ((0, taskStore_1.taskStore)().storeItemId) {
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    itemId: stimulus.itemId,
                });
            }
            if (stimulus.assessmentStage === 'test_response') {
                taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
            }
            if (responseType === 'button' || responseType === 'slider-button') {
                const calculatedRt = Math.round(endTime - startTime);
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    rt: calculatedRt,
                    responseLocation: responseIdx,
                });
            }
            if (!runCat) {
                (0, helpers_1.setSkipCurrentBlock)(stimulus.trialType);
            }
            if (terminateCat) {
                (0, helpers_1.shouldTerminateCat)();
            }
        },
    };
};
exports.slider = slider;
